import { IconNotificationDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import EmailCapture from './EmailCapture'
import classes from './SeriesEmailCapture.module.scss'

const SeriesEmailCapture = (props) => {
  const { t } = useTranslation('@mc/next')

  return (
    <EmailCapture
      className='mc-background--color-medium mc-p-8 mc-corners--3'
      buttonType='secondary'
      thankYouText={t('emailCaptureBanner.form.success.seriesDescription')}
      {...props}
    >
      <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-lg-start mc-mb-5 mc-mb-md-0'>
        <div
          className={`mc-corners--circle mc-p-2 mc-mr-3 mc-mb-3 mc-mb-sm-0 ${classes.notificationIcon}`}
        >
          <IconNotificationDefault size={3} />
        </div>
        <span className='mc-text-h4 mc-text--center mc-text-sm--left'>
          {t('series.emailCapture.header')}
        </span>
      </div>
    </EmailCapture>
  )
}

export default SeriesEmailCapture
